<template>
    <span>
        <b-form-input v-if="readonly" :value="getFilterType()"
                :readonly="readonly"></b-form-input>
        <b-card v-if="!readonly">
        <b-card-body v-if="!readonly">
            <b-row>
                <b-col>
                    <b-button variant="outline" size="sm" v-for="x in colliFilterTypes" :key="x.text"
                        @click="work = x.value">{{ x.text }}</b-button>
                </b-col>
            </b-row>
            <strong>{{ getFilterType() }}</strong>
            <!-- <b-button size="sm" variant="secondary" title="Kod" @click="jsonvisible=!jsonvisible"><b-icon-code-square></b-icon-code-square> Kod</b-button> -->
            <!-- <v-jsoneditor v-show="jsonvisible" v-model="work" :options="options"
                                :plus="true" :height="'420px'" @error="onError"></v-jsoneditor> -->


            <!-- <queryviewconditionset :columns="columns" filters="filters"></queryviewconditionset> -->
            <b-form-textarea v-model="work" :state="isValid(work)"></b-form-textarea>

        </b-card-body>
    </b-card>
    </span>
    
</template>
<script>
// import VJsoneditor from 'v-jsoneditor/src/index';
import queryviewconditionset from "../queryview/queryviewconditionset";

export default {
    name: 'filtereditor',
    components: { queryviewconditionset },
    props: {
        value: String,
        readonly: Boolean,
        filters: [{}],
        columns: [
            {
                Name: "OrdertypId",
                PrettyName: "Ordertyp",
                ColName: "ServiceTypeId",
                ColumnType: "number",
            },
            {
                Name: "Tur",
                ColName: "TourName",
                ColumnType: "text",
            },
            {
                Name: "Produktnyckel",
                ColName: "ProductKey",
                ColumnType: "text",
            },
        ],
    },
    data() {
        return {
            work: null,
            colliFilterTypes: [
                { value: '', text: '(ALLA)' },
                { value: 'ServiceTypeId!=50', text: 'Övriga, ej butiksorder' },
                { value: 'ServiceTypeId==50', text: 'Butiksorder' },
            ],
            options: {
                "mode": "code",
                "search": true,
                onEditable: (path, field, value) => true,
            },
            jsonvisible: false,
        }
    },
    created() {
        this.work = this.value;
    },
    watch: {
        work: function () {
            const v = this.work;
            this.$emit('input', v);

            // if (typeof v === 'string' || v instanceof String)
            //     this.$emit('input',v); 
            // else 
            //     this.$emit('input',JSON.stringify(v)); 
        }
    },
    methods: {
        getFilterType() {
            if (!this.work)
                return ("(ALLA)");
            var f = this.colliFilterTypes.find(x => x.value == this.work);

            const res = f ? f.text : "(SPECIAL)";
            return res;
        },
        onError() {

        },
        isValidJson(text) {
            // if (text)
            //     return (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
            //         replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
            //         replace(/(?:^|:|,)(?:\s*\[)+/g, '')));
            if(!text)
                return false;
            try {
                const o = JSON.parse(text);
                return true;
            } catch (error) {
                return false;
            }
            
                    
        },
        isValid(text) {
            const s = this.getFilterType();
            return (s == '(SPECIAL)') ? this.isValidJson(text) : true;
        }
    }

}

</script>